import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { fetchMaintenanceById } from '../reducers/MaintenanceSlice';
import CircularProgress from '@mui/material/CircularProgress';
import moment from 'moment';

const ViewMaintenance = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { maintenance, status, error } = useSelector(state => state.maintenances);

    useEffect(() => {
        if (id) {
            dispatch(fetchMaintenanceById(id));
        }
    }, [id, dispatch]);

    if (status === 'loading') {
        return <div className="d-flex justify-content-center align-items-center h-100"><CircularProgress /></div>;
    }

    if (status === 'failed') {
        return <div>Failed to load Maintenance data: {error}</div>;
    }

    if (!maintenance) {
        return <div>No Maintenance data available.</div>;
    }
    return (
        <>
            <div className="container my-4 text-white view-student">
                <div className="row" id="studentContainer">
                    <div className="col">
                        <div className="card-body">
                            <div className="card student-card p-4">
                                <h2 className='text-center text-white mb-2'>AK Boys Hostel</h2>
                                <div className="overflow-x-auto">
                                    <table className="table-auto w-100 border border-gray-300 text-white shadow-md rounded-lg">
                                        <tbody>
                                            {[
                                                ["Maintenance ID", maintenance?._id, "Title", maintenance?.title],
                                                ["Type", maintenance?.maintenanceType, "Issue", maintenance?.issueDescription],
                                                ["Location", maintenance?.location, "Assigned To", maintenance?.assignedTo],
                                                ["Start Date", moment(maintenance?.workStartDate)?.format("DD-MM-YYYY"), "Completion Date", moment(maintenance?.workCompletionDate)?.format("DD-MM-YYYY")],
                                                ["Status", maintenance?.status, "Total Cost", maintenance?.totalCost?.toLocaleString()],
                                                ["Payment Method", maintenance?.paymentMethod, "Payment Date", moment(maintenance?.paymentDate).format("DD-MM-YYYY")],
                                                ["Paid By", maintenance?.paidBy,],
                                                ["Created At", moment(maintenance?.createdAt)?.format("DD-MM-YYYY"), "Updated At", moment(maintenance?.updatedAt).format("DD-MM-YYYY")]
                                            ].map((row, rowIndex) => (
                                                <tr key={rowIndex} className="border-b border-gray-300">
                                                    {row.map((cell, cellIndex) => (
                                                        <td key={cellIndex} className="px-4 py-2 border border-gray-300">
                                                            <strong>{cellIndex % 2 === 0 ? cell : ""}</strong> {cellIndex % 2 !== 0 ? cell : ""}
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ViewMaintenance
